import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import ErrorBoundary from 'components/ErrorBoundary';
import NotFound from 'pages/NotFound';
import MessageSendingInterface from './pages/message-sending-interface';
import PaymentSuccess from './pages/payment-success';
import PaymentFailed from './pages/payment-failed';
import MakanCondolence from './pages/crowd-expression/makan';
import AboutUs from './pages/about-us';
import PaymentCallback from './pages/payment-callback';
import Followup from './pages/followup';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<MessageSendingInterface />} />
          <Route
            path="/message-sending-interface"
            element={<MessageSendingInterface />}
          />
          <Route path="/crowd-expression/makan" element={<MakanCondolence />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/payment/callback" element={<PaymentCallback />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/followup" element={<Followup />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
